import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemPassport } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import PassportDialog from "../../Dialogs/lostWallet/PassportDialog";
import { countryList } from "../../../util/CommonLists";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";
import moment from "moment";

const Passport: React.FunctionComponent<{ requestDataCallback(): void; walletItemPassports: WalletItemPassport[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [passportDialogIsVisible, setPassportDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [passportNumber, setpassportNumber]:any= useState([]);
    const [PassPortDateOfBirthText,setPassPortDateOfBirthText]:any = useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemPassport): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showPassportDialog = (selectedItem: WalletItemPassport): any => {
        setSelectedItem(selectedItem);
        setPassportDialogIsVisible(true);
    };

    const closePassportDialog = (): any => {
        setPassportDialogIsVisible(false);
    };

     const togglePassportNumberVisibility=(passport:any)=>{
        if (passportNumber.length > 0) {
            const index = passportNumber.findIndex((element: any) => element.passportNumber ===  passport.passportNumber);
         if (index >= 0) {
            passportNumber.splice(index, 1);
            setpassportNumber([...passportNumber]);
        } 
         else {
            setpassportNumber([...passportNumber, passport]);
         }
          } else {
            setpassportNumber([...passportNumber , passport]);
         }
     }

     const toggleDateOfBirthVisibility=(passport:any) =>{
        if (PassPortDateOfBirthText.length > 0) {
            const index = PassPortDateOfBirthText.findIndex((element: any) => element.dateOfBirth ===  passport.dateOfBirth);
         if (index >= 0) {
            PassPortDateOfBirthText.splice(index, 1);
            setPassPortDateOfBirthText([...PassPortDateOfBirthText]);
        } 
         else {
            setPassPortDateOfBirthText([...PassPortDateOfBirthText, passport]);
         }
          } else {
            setPassPortDateOfBirthText([...PassPortDateOfBirthText , passport]);
         }
     }
    return (
        <React.Fragment>
            {props.walletItemPassports &&
                props.walletItemPassports.map((passport: WalletItemPassport, index) => (
                    <div className="data-row" key={"passport-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"passport-" + index}
                                onClick={() => toggle(`passport-${index}-details`, `passport-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {passport.firstName + " " + passport.lastName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.passport.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"passport-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"passport-" + index + "-title"}
                                    aria-labelledby={"passport-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.passportNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-number"}>
                                              {passport &&
                                                passport.passportNumber &&   passportNumber.findIndex((element: any) => element.passportNumber ===  passport.passportNumber) < 0 ?
                                                     `${"*".repeat(passport.passportNumber.substr(0,passport.passportNumber.length - 4).length)}${passport.passportNumber.substr(
                                                        passport.passportNumber.length - 4
                                                      )}`:  passport.passportNumber} 

                                              <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    togglePassportNumberVisibility(passport);
                                                }}
                                                title={"Show PassPortNumber Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            passportNumber.findIndex((element: any) => element.passportNumber ===  passport.passportNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide PassPortNumber Text</span>
                                            </button>        
                                           </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-first-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.firstName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-first-name"}>
                                                {passport.firstName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-middle-initial"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.middleInitial")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-middle-initial"}>
                                                {passport.middleName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-last-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.lastName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-last-name"}>
                                                {passport.lastName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-suffix"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.suffix")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-suffix"}>
                                                {passport.suffix}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-sex"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.sex")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-sex"}>
                                                {passport.sex}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-type"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.type")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-type"}>
                                                {passport.passportType === "P"
                                                    ? tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dropdownPassportList.regular")
                                                    : passport.passportType === "G"
                                                    ? tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dropdownPassportList.greencardHolder")
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-issuing-country"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.country")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-issuing-country"}>
                                                {countryList.find((c) => c.code === passport.issuingCountry)?.name}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-passport-code"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.code")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-passport-code"}>
                                                {passport.passportCode}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-date-of-birth"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dob")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-date-of-birth"}>
                                              {passport.dateOfBirth  && PassPortDateOfBirthText.findIndex((element: any) => element.dateOfBirth ===  passport.dateOfBirth) < 0 
                                                ? (i18nService.get("Country") === "US" 
                                                   ? moment(passport.dateOfBirth).format("MMM D ****")
                                                   : i18nService.get("Country") === "CA" || i18nService.get("Country") === "TW"
                                                   ? moment(passport.dateOfBirth).format("**** MMM D")
                                                   : moment(passport.dateOfBirth).format("D MMM ****"))
                                                : passport.dateOfBirth && getFormattedDate(i18nService.get("Country"), passport.dateOfBirth)}
                                                <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                   toggleDateOfBirthVisibility(passport);
                                                }}
                                                title={"Show DOB Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={passport.dateOfBirth ?`las ${
                                                            PassPortDateOfBirthText.findIndex((element: any) => element.dateOfBirth ===  passport.dateOfBirth) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`: "data-value"}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide PassPortDateOfBirthText</span>
                                            </button>  
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-place-of-birth"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.placeOfBirth")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-place-of-birth"}>
                                                {passport.placeOfBirth}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-nationality"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.nationality")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-nationality"}>
                                                {passport.nationality}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-issue-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.issueDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-issue-date"}>
                                                {passport.issueDate && getFormattedDate(i18nService.get("Country"), passport.issueDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-expiration-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.expiryDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-expiration-date"}>
                                                {passport.expiryDate && getFormattedDate(i18nService.get("Country"), passport.expiryDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"passport-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"passport-" + index + "-notes"}>
                                                {passport.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(passport)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showPassportDialog(passport)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-passport-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="passport"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {passportDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-passport-wallet" title="Edit Passport Wallet" closeDialog={closePassportDialog}>
                    <PassportDialog requestDataCallback={props.requestDataCallback} closeDialog={closePassportDialog} walletItem={selectedItem} isNew={false} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default Passport;
